"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-reports.disabled': '高级报告功能在您当前的计划中不可用。',
};
